/**
 * IE対策
 */
import './modules/ie11';

/**
 * スマホ100vh対策
 */
import { ViewportModule } from './modules/viewport';
const $viewport = new ViewportModule.Service();

/**
 * アコーディオン
 */
import { AccordionActionModule } from './modules/accordion_action';
const $accordionActionModule = new AccordionActionModule.Service();

/**
 * 読み込み完了
 */
import { LoadModule } from './modules/load';
const $load = new LoadModule.Service();

/**
 * コンポーネント
 * アコーディオン
 */
import { AccordionModule } from './components/Molecules/accordion';
const $accordionModule = new AccordionModule.Service();

/**
 * コンポーネント
 * グローバルメニューボタン
 */
import { GlobalMenuButtonModule } from './components/Molecules/globalMenuButton';
const $globalMenuButtonModule = new GlobalMenuButtonModule.Service();

/**
 * コンポーネント
 * serviceList__item
 */
import { ServiceListItemModule } from './components/Molecules/serviceListItem';
const $serviceListItemModule = new ServiceListItemModule.Service();
